<template>
	<sf-button v-if="isButton_(scrId, 'AD')" :onClick="releaseAction">{{ getMessage_('SWCC000786') }}</sf-button>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/ControlManagement/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		releaseAction() {
			try {
				// 유효성 검사
				if (this.selection.length == 0) {
					this.$sf_showMessage({
						icon: 'error',
						title: this.getMessage_('SWCC000787'), // 제어권 선택
						message: this.getMessage_('SWCC000109') // 행을 선택해 주세요
					});
					return;
				}

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('SWCC000963'), //제어권을 반납하시겠습니까?
					buttons: [{ title: this.getMessage_('SWCC000786'), clickFn: () => this.release() }] //반납
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},

		release() {
			this.$sf_toggleLoading(true);
			this.postControl_({ plantCd: this.user.plantCd, controlList: this.selection })
				.then(response => {
					this.$sf_toast({ type: 'ok', message: response.messageCd != '' ? this.getMessage_(response.messageCd) : response.message });
					// this.getControlList_({ ...this.searchParams, currentPage: 1, pageUnit: this.groups.pageUnit });

					this.getControlList_({
						plantCd: this.searchParams.plantCd,
						scrId: this.searchParams.controlScrId,
						scrName: this.searchParams.controlScrName,
						userId: this.searchParams.userId,
						onlyIng: this.searchParams.onlyIng,
						currentPage: 1,
						pageUnit: this.groups.pageUnit
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>
<style></style>
